import EmployeesCollectionsBootstrap from 'modules/performance_v2/lib/EmployeesCollectionsBootstrap'
import EmployeePerformancePage from 'modules/performance_v2/pages/EmployeePerformancePage'

const EmployeeRootPage = () => {
  return (
    <EmployeesCollectionsBootstrap>
      <EmployeePerformancePage rootPage="employee" />
    </EmployeesCollectionsBootstrap>
  )
}

export default EmployeeRootPage
